import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export interface FormFieldBindingProps {
  model: SearchCriteriaModel;
  validators: object[];
  updateModelCallback?: (event) => void;
  analytics?: AnalyticsStore;
}

export interface FormFieldBindingComponent {
  updateModel?: (event: FieldEvent) => void;
  registerValidator?: (event) => void;
}

interface FieldEvent {
  target: {
    name: string;
    value?: any;
    track?: boolean;
    userHistory?: boolean;
    delay?: boolean;
  };
}

export function FormFieldBinding(WrappedComponent): any {
  return class<T extends FormFieldBindingProps> extends React.Component<T> {
    public static wrappedComponent = WrappedComponent;

    public updateModel = (event: FieldEvent) => {
      const { model, updateModelCallback } = this.props;
      const target = event && event.target;
      const name = target && target.name;
      const value = target && target.value;
      const userHistory = target && target.userHistory;
      const oldValue = model && model[name];

      // do not check for value
      // value could reset part of the model: '', undefined, null
      if (model && name) {
        // update state via mobx
        model[name] = value;
      }

      if (typeof updateModelCallback === 'function') {
        updateModelCallback(event);
      }

      if (target && target.track === true) {
        this.trackUpdate(name, value, oldValue, userHistory);
      }
    };

    private trackUpdate(name?: string, value?: string, oldValue?: string, userHistory?: boolean): void {
      const { analytics } = this.props;
      const pristine = value === oldValue ? '.(pristine)' : '';
      const recentSearchesEvent = name === 'destination' && userHistory;

      if (analytics && typeof analytics.trackEvent === 'function') {
        if (recentSearchesEvent) {
          analytics.trackEvent(`:RecentSearches`, `${name} has changed from Typeahead Recent Searches`, null);
        } else {
          analytics.trackEvent(`.${name}.${value}${pristine}`, `${name} has changed`, null);
        }
      }
    }

    public registerValidator = validator => {
      const { validators } = this.props;

      if (validators) {
        validators.push(validator);
      }
    };

    public render() {
      return <WrappedComponent updateModel={this.updateModel} registerValidator={this.registerValidator} {...this.props} />;
    }
  };
}
